<template>
  <div style="padding: 16px">
    <div class="d-flex d-aligncnter">
      <img
        class="img-24"
        src="@/assets/img/academic/alarm.svg"
        style="width: 0.5rem; height: 0.5rem"
      />
      <div class="left-title ml-4">各学院学业预警分布</div>
    </div>
    <div class="grey mt-16" style="font-size: 0.4rem">预警总数</div>
    <div class="grey mt-8 d-aligncnter" style="font-size: 0.6rem">
      22
      <div
        class="d-flex mt-8 d-aligncnter ml-4"
        style="font-size: 0.4rem; margin-left: 8px"
      >
        <span class="green">较作日降低</span>
        <span class="yellow">1%</span>
        <img class="img-16 ccc" src="@/assets/img/academic/upy.svg" />
      </div>
    </div>

    <div class="" style="margin-top: -20px">
      <div class="echarts">
        <div
          id="month"
          :style="{
            width: '100%',
            height: '260px',
            margin: '0 auto',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['warmingData'],
  data() {
    return {}
  },
  watch: {},
  created() {
    // var myChart1 = this.$echarts.init(document.getElementById('month'))
    // myChart1.setOption(this.option1)
  },
  mounted() {
    this.drawData()
  },
  computed: {},
  methods: {
    drawData() {
      var myChart1 = this.$echarts.init(document.getElementById('month'))
      this.option1 = {
        tooltip: {},
        axisLabel: {
          color: '#ffffff66',
          fontSize: 12,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 30,
            formatter: function (value) {
              if (value.length > 4) {
                return value.slice(0, 3) + '...'
              }
              return value
            },
          },
          //   data: this.monthColleges,
          data: [
            '计算',
            '信电',
            '医学院',
            '外国语',
            '传媒',
            '法学院',
            '艺术',
            '怀卡托',
            '国土',
            '旅游',
            '马克思',
          ],
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          minInterval: 50,
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        series: [
          {
            name: '预警人数',
            type: 'bar',
            stack: 'one',
            data: [100, 110, 80, 90, 110, 160, 100, 110, 80, 90, 110],
            // data: this.warmingData,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB612' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
</style>
